
////// roles 
export const ADMIN_ROLE_ID = 1;
export const BA_ADMIN = 2;
export const BA_VIEW = 3;
export const CA_VIEW = 4;
export const CA_ADMIN = 5;
export const CA_ANALYST_ROLE_ID = 5;
export const COUNTRYPIC_ROLE_ID = 6;
export const TDS_ROLE_ID = 7;
/**
 * Store360 (project 1) role with the same user-setup fields and access as TDS (7).
 */
export const TDS_EQUIVALENT_ROLE_ID = 24;

export const TDS_EQUIVALENT_ROLE_IDS: number[] = [
  TDS_ROLE_ID,
  TDS_EQUIVALENT_ROLE_ID,
];

export function isTdsEquivalentRole(
  roleId: number | null | undefined,
): boolean {
  return (
    roleId != null && TDS_EQUIVALENT_ROLE_IDS.includes(Number(roleId))
  );
}

export const TRAINER_ROLE_ID = 9;
export const PROMOTER_ROLE_ID = 10;
export const TDL_ROLE_ID = 8;
export const TRADE_EVENT_SPECIALIST = 11;
export const TRADE_OPS_MANAGER = 12;
export const TRADE_OPERATIONS = 13;
export const SALES = 14;
export const SALES_MANAGER = 15;
export const SALES_DIRECTOR_GM = 16;
export const CA_TRAINER = 17;
export const SUPER_BA_ADMIN = 23;

/**
 * Roles that share Admin-level platform privileges (id-based).
 * Same pattern as BA_ADMIN_LIKE_ROLE_IDS — check by role id, not by name.
 * Admin = 1, Super BA Admin = 23.
 */
export const ADMIN_EQUIVALENT_ROLE_IDS: number[] = [
  ADMIN_ROLE_ID,
  SUPER_BA_ADMIN,
];

export function isAdminEquivalentRole(
  roleId: number | null | undefined,
): boolean {
  return (
    roleId != null && ADMIN_EQUIVALENT_ROLE_IDS.includes(Number(roleId))
  );
}

export const BA_ADMIN_LIKE_ROLE_IDS: number[] = [BA_ADMIN, SUPER_BA_ADMIN];

export function isBaAdminLikeRole(roleId: number | null | undefined): boolean {
  return roleId != null && BA_ADMIN_LIKE_ROLE_IDS.includes(Number(roleId));
}

/**
 * The platform role that marks an account as an e-Warranty DEALER account,
 * compared case-insensitively. Seeded BY NAME (not id) in
 * ddl/e_warranty_01b_dealer_login.sql, because the ids above are
 * environment-specific facts rather than schema.
 *
 * Lives here, and not beside its users, because THREE places across TWO apps
 * must give the same answer and must not drift:
 *
 *   ewarranty-service  DealerLoginService  ATTACHES it to every account it
 *                                          provisions
 *   ewarranty-service  ActingDealerService READS it to decide whether a caller
 *                                          is a dealer to be clamped to their
 *                                          own rows, or a portal user with the
 *                                          unrestricted view
 *   user-service       AuthService         requires it before a dealer login
 *                                          code may resolve to an account
 *
 * Note it is deliberately absent from MOBILE_APPLICATION_LOGIN_ROLE_IDS: the
 * Dealer role carries authorization (it lands in the JWT), not authentication.
 */
export const DEALER_ROLE_NAME = 'dealer';

export const LEVEL_1_GROUP_ROLES: number[] = [ADMIN_ROLE_ID, BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, COUNTRYPIC_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS, SALES, SALES_MANAGER, SALES_DIRECTOR_GM, CA_TRAINER];
export const MOBILE_APPLICATION_LOGIN_ROLE_IDS: number[] = [
    ...LEVEL_1_GROUP_ROLES,
    PROMOTER_ROLE_ID,
];
export const LEVEL_2_GROUP_ROLES = [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, COUNTRYPIC_ROLE_ID, CA_TRAINER];
export const LEVEL_3_GROUP_ROLES = [TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, PROMOTER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS]; //7,24,8,9,10
export const LEVEL_4_GROUP_ROLES = [TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS]; //7,24,8,9,11,12,13
export const LEVEL_5_GROUP_ROLES = [ADMIN_ROLE_ID, BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER];
export const LEVEL_6_GROUP_ROLES = [COUNTRYPIC_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, PROMOTER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS]; //6,7,24,8,9,10
export const LEVEL_7_GROUP_ROLES = [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER];
export const LEVEL_8_GROUP_ROLES = [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW];
export const LEVEL_9_GROUP_ROLES = [CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER];//4,5
export const PROMOTER_CATEGORY_ACCESS_ROLES = [ADMIN_ROLE_ID, BA_ADMIN, SUPER_BA_ADMIN, CA_ANALYST_ROLE_ID];
export const TDS_LEVEL_GROUP_ROLES = [TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS]; //7,24,11,12,13
export const USER_HAVING_SINGLE_COUNTRY_ACCESS = [COUNTRYPIC_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS, TRAINER_ROLE_ID]; //6,7,24,8,9,10,11,12,13
///
export const FIELD_WORKER_GROUP_ROLES = [TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, TRAINER_ROLE_ID, PROMOTER_ROLE_ID, TRADE_EVENT_SPECIALIST, TRADE_OPS_MANAGER, TRADE_OPERATIONS]; //7,24,8,9,10 
export const TRAINER_TDS_TDL_PROMOTER_ROLES = [TRAINER_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID, PROMOTER_ROLE_ID]; //9,7,24,8,10
export const SALES_LEVEL_GROUP_ROLES = [SALES, SALES_MANAGER, SALES_DIRECTOR_GM]; //14,15,16
////// status
export const PENDING = 'Pending';
export const APPROVED = 'Approved';
export const REJECTED = 'Rejected';
export const CANCELLED = 'Cancelled';
export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const DELETED = 'Deleted';
export const COMPLETED = 'Completed';
export const IN_PROGRESS = 'In Progress';
export const NOT_STARTED = 'Not Started';
export const ON_HOLD = 'On Hold';
export const NOT_APPLICABLE = 'Not Applicable';
export const PENDING_APPROVAL = 'Pending Approval';

////staus with id
export const PENDING_ID = 1;
export const IN_PROGRESS_ID = 2;
export const COMPLETED_ID = 3;
export const CANCELLED_ID = 4;
export const CHECK_IN_ID = 5;
export const CHECK_OUT_ID = 6;

///country 
export const TEST_COUNTRY_ID = 10;

/////jp type
export const PLANNED_TYPE_ID = 1;
export const UNPLANNED_TYPE_ID = 2;


////Brand Id
export const ELX_BRAND_ID = 1;

///Survey id 
export const SURVEY_SELLOUT_ID = 1;
export const SURVEY_PROMOTER_SHARE_ID = 2;
export const SURVEY_FIXTURE_SHARE_ID = 3;
export const SURVEY_DISPLAY_MATRIX_POSM_ID = 4;
export const SURVEY_DISPLAY_SHARE_ID = 5;

// FIle Size
export const TEN_MB = 10 * 1024 * 1024;

//project Management 
export const PROJECT_MANAGEMENT_STATUS_ID = {
    not_started: 0,
    approved: 1,
    draft: 2,
    rejected: 3,
    waiting_for_approval: 4,
    quotation_confirmed: 5,
    quotation_quantity_confirmed: 6,
    scheduled: 7,
    delivered: 8,
    lost: 9,
    cancelled: 10,
    re_scheduled: 11,
    lead_cancelled: 12,
    re_approval_pending: 13,
    re_approval_rejected: 14
}

// Project Management Status Strings
export const PROJECT_MANAGEMENT_STATUS = {
    APPROVED: 'Approved',
    DRAFT: 'Draft',
    REJECTED: 'Rejected',
    WAITING_FOR_APPROVAL: 'Waiting For Approval',
    QUOTATION_CONFIRMED: 'Quotation Confirmed',
    QUOTATION_QUANTITY_CONFIRMED: 'Quotation Quantity Confirmed',
    SCHEDULED: 'Scheduled',
    DELIVERED: 'Delivered',
    CANCELLED: 'Cancelled',
    LEAD_CANCELLED: 'Lead Cancelled',
    RE_SCHEDULED: 'Re-Scheduled',
    RE_APPROVAL_PENDING: 'Re-Approval Pending',
    RE_APPROVAL_REJECTED: 'Re-Approval Rejected'
}




export const MASTER_USER_URL = '/admin/user/master-user';
export const USER_LIST_URL = '/admin/user/users';
export const PRODUCT_URL = '/admin/product/product-line';
export const STORE_URL = '/admin/store/store-list';
export const TASK_LIST_URL = '/admin/task-management/task-list';
export const JOURNEY_URL = 'admin/journey/journey-list';
export const SURVEY_INVITE_URL = '/bottomNavigation';
export const ACTIVE_SURVEY_LIST = '/admin/survey/survey-list';
export const ALL_LEAVE_URL = '/admin/leave-management/all-request'
export const MOBILE_URL = '/bottomNavigation';
export const PRICE_MAPPING_URL = '/admin/user/price-mapping';
export const TARGET_SETTING_URL = '/admin/setting/target-setting';
export const USER_STORE_MAPPING_URL = '/admin/store/user-store-mapping';
export const REPORTING_MANAGER_MAPPING_URL = '/admin/master-management/reporting-manager-mapping';
export const AREA_GROUP_URL = '/admin/user/area-mapping';
export const DISPLAY_SHARE_BRAND_MAPPING_URL = '/admin/user/display-share-brand-mapping';
export const LOCATION_TYPE_ID = {
    AREA_GROUP: 1,
    STATE: 2,
    CITY: 3,
    BY_ACCOUNT: 4
}

export const IS_GROUP_TRAINING = 1;
export const IS_FIELD_TRAINING = 2;



export const TEST_ACCOUNT_EMAILS = [
    'one.sd@electrolux.com', 'one.sm@electrolux.com', 'one.s@electrolux.com', 'nehaca@electrolux.com',
    'adeel.ahmad@electrolux.com', 'vn_manager1@electrolux.com', 'vn_manager2@electrolux.com', 'vn_sale1@electrolux.com',
    'vn_sale2@electrolux.com', 'vn_sale3@electrolux.com', 'tw_manager1@electrolux.com', 'tw_manager2@electrolux.com',
    'tw_sale1@electrolux.com', 'tw_sale2@electrolux.com', 'tw_sale3@electrolux.com', 'sg_manager1@electrolux.com',
    'sg_manager2@electrolux.com', 'sg_sale1@electrolux.com', 'sg_sale2@electrolux.com', 'sg_sale3@electrolux.com',
    'th_manager1@electrolux.com', 'th_manager2@electrolux.com', 'th_sale1@electrolux.com', 'th_sale2@electrolux.com',
    'th_sale3@electrolux.com', 'my_manager1@electrolux.com', 'my_manager2@electrolux.com', 'my_sale1@electrolux.com',
    'my_sale2@electrolux.com', 'my_sale3@electrolux.com', 'id_manager1@electrolux.com', 'id_manager2@electrolux.com',
    'id_sale1@electrolux.com', 'id_sale2@electrolux.com', 'id_sale3@electrolux.com', 'kr_manager1@electrolux.com',
    'kr_manager2@electrolux.com', 'kr_sale1@electrolux.com', 'kr_sale2@electrolux.com', 'kr_sale3@electrolux.com'
];
